import { useFeatureFlagsContext } from 'src/providers/FeatureFlagsProvider/FeatureFlags.context';

export function useWorkspaceAgentRollout() {
  const { featureFlags, hasLoadedFeatureFlags } = useFeatureFlagsContext();
  return (
    hasLoadedFeatureFlags && featureFlags['leads_workspace-agent'] === true
  );
}
